import React from "react";
import "./INeedTo.css"
import img from "./ClassExample.png"

const INeedToB = () => (
  <div className="INeedToMainDiv">

    <h1>Namespaces</h1>

    <p>iNeed2 uses static variables and methods to implement namespaces. </p>
    <p>Consider:</p>


    <img src={img} className="ineedtocode" alt="code snippet" />

    <p>In this example, SomeClass can be used as a namespace.  The function, someFunction,
        can be called by writing "SomeClass.someFunction()." and the variable,
       someVariable, can be accessed by writing "SomeClass.someVariable"</p>



  </div>
);

export default INeedToB;


// WEBPACK FOOTER //
// ./src/components/iNeed2_Slides/INeedToB.js